import { Input, Tabs, TabItem, Dropdown, Button, CapsuleTab } from '@/components/atoms/index'
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Icon } from '@/icons';
import { vars } from 'style/theme.css';
import LearningCard from '@/components/organisms/Card/LearningCard';
import AcademyExamTable from '@/components/organisms/Table/AcademyExamTable';
import VocabularyTable from '@/components/organisms/Table/VocabularyTable';
import TrophyBadgeCard from '@/components/organisms/Card/TrohyBadgeCard';
import { useParams } from 'react-router-dom';
import { academyTeacherApi } from '@/services/api';
import { message, Modal as AntModal } from 'antd';
import { Modal as AppModal } from '@/components/organisms/Modal/Dialog';

const AcademyTeacherDetail = () => {
  const { teacherId } = useParams<{ teacherId: string }>();
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<any>(null);
  const [form, setForm] = useState({ name: '', phone: '' });
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const formatYmd = (s?: string | null, withTime = false) => {
    if (!s) return '';
    const parsed = dayjs(s);
    if (parsed.isValid()) {
      // withTime=true: 시분초까지 표기
      return parsed.format(withTime ? 'YYYY.MM.DD HH:mm:ss' : 'YYYY.MM.DD');
    }
    const only = String(s).split('T')[0];
    const parts = only.split('-');
    if (parts.length === 3) return `${parts[0]}.${parts[1]}.${parts[2]}`;
    return s as string;
  };

  useEffect(() => {
    const run = async () => {
      if (!teacherId) return;
      setLoading(true);
      try {
        const res: any = await academyTeacherApi.detail(teacherId);
        const data = res?.data || res;
        setDetail(data);
        setForm({ name: data?.name || '', phone: data?.phone || '' });
      } catch (e: any) {
        const msg = e?.response?.data?.message || '강사 상세 조회 실패';
        message.error(msg);
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [teacherId]);

  return (
    <main className='flex flex-col flex-1 py-8'>
            <div className='flex flex-row justify-between items-center'>
                <h1 className='heading1'>강사상세</h1>
            </div>
            <div className="mt-3">
                <div className="w-full">
                    <ul>
                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>아이디</p>
                            <Input disabled value={detail?.loginId || ''} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>학원코드</p>
                            <Input disabled value={detail?.academyCode || ''} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>이름</p>
                            <Input
                              placeholder='이름을 입력해주세요'
                              className='max-w-[500px] w-full'
                              value={form.name}
                              onChange={(e: any) => setForm((v) => ({ ...v, name: e.target.value }))}
                            />
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>생년월일</p>
                            <Input disabled value={formatYmd(detail?.birthDate, false) || ''} className='max-w-[500px] w-full'/>
                        </li>


                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>연락처</p>
                            <Input placeholder='연락처를 입력해주세요' className='max-w-[500px] w-full' value={form.phone} onChange={(e:any)=>setForm(v=>({...v, phone: e.target.value}))}/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>가입 상태</p>
                            <Input disabled value={'승인'} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>강사 상태</p>
                            <Input disabled value={detail?.status || ''} className='max-w-[500px] w-full'/>
                        </li>

                        <li className='flex py-5 border-b border-gray-200'>
                            <p className='flex-none max-w-[150px] w-full text-gray-500'>가입신청일</p>
                            <Input disabled value={formatYmd(detail?.registrationDate, true) || ''} className='max-w-[500px] w-full'/>
                        </li>

                    </ul>
                    <div className='flex justify-end gap-2 mt-4'>
                        <Button intent='secondary' className='w-auto px-4' onClick={() => setPasswordModalOpen(true)}>비밀번호 변경</Button>
                        <Button intent='secondary' className='w-[120px]' onClick={async()=>{
                          if (!teacherId) return;
                          const ok = await AppModal.confirm(
                            <div className='p-4'>
                              정말 퇴원 처리하시겠습니까?
                            </div>,
                            '퇴원',
                            '취소'
                          );
                          if (!ok) return;
                          try{
                            await academyTeacherApi.withdraw(teacherId);
                            message.success('퇴원 처리되었습니다.');
                            setDetail((d:any)=>({ ...(d||{}), status: '퇴원', withdrawnAt: new Date().toISOString() }));
                          }catch(e:any){
                            const msg = e?.response?.data?.message || '퇴원 처리 실패';
                            message.error(msg);
                          }
                        }}>퇴원</Button>
                        <Button className='w-[120px]' onClick={async()=>{
                          try{
                            await academyTeacherApi.update(teacherId, { name: form.name, phone: form.phone });
                            message.success('저장되었습니다.');
                          }catch(e:any){
                            const msg = e?.response?.data?.message || '저장 실패';
                            message.error(msg);
                          }
                        }}>저장</Button>
                    </div>
                </div>
            </div>
            <AntModal
                title="비밀번호 변경"
                open={passwordModalOpen}
                onCancel={() => {
                    setPasswordModalOpen(false);
                    setNewPassword('');
                }}
                onOk={async () => {
                    if (!newPassword || newPassword.length < 8) {
                        message.error('비밀번호를 8자 이상 입력해주세요.');
                        return;
                    }
                    try {
                        await academyTeacherApi.updatePassword(teacherId, newPassword);
                        message.success('비밀번호가 변경되었습니다.');
                        setPasswordModalOpen(false);
                        setNewPassword('');
                    } catch (e: any) {
                        message.error(e?.response?.data?.message || '비밀번호 변경 실패');
                    }
                }}
                okText="변경"
                cancelText="취소"
            >
                <div className="pt-4 pb-2">
                    <p className="mb-2 text-gray-600">새로운 비밀번호를 입력해주세요.</p>
                    <Input
                        type="password"
                        placeholder="새 비밀번호"
                        value={newPassword}
                        onChange={(e: any) => setNewPassword(e.target.value)}
                        className="w-full"
                    />
                </div>
            </AntModal>
        </main>
  )
}

export default AcademyTeacherDetail